<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, bind }">
      <div
        v-on="on"
        v-bind="bind"
        @click="$emit('click')"
        class="menu-item"
        :class="{ selected }"
        style="
          padding: 8px;
          display: flex;
          align-items: center;
          position: relative;
        "
      >
        <div style="cursor: pointer">
          <slot></slot>
        </div>
      </div>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "ImageModeMenuItem",
  props: {
    selected: {
      type: Boolean,
      required: true,
    },
    tooltip: {
      type: String,
      required: true,
    },
  },
})
</script>

<style scoped>
.menu-item {
  cursor: pointer;
  background-color: white;
  color: #424242;
  transition: background-color 0.3s;
}

.menu-item:hover {
  background-color: #f5f5f5;
}

.selected {
  background-color: #518efc;
  color: white;
}
</style>
